import { db } from "@/lib/local/db";
import { useFiscalStore } from "@/store/fiscal-store";

const TTL_DEFAULT_MS = 1000 * 60 * 10; // 10 min

export const analyticsCache = {
  async get<T = any>(id: string, ttlMs = TTL_DEFAULT_MS): Promise<T | null> {
    const userId = useFiscalStore.getState().userId;
    if (!userId) return null;

    // A chave primária agora é composta: [userId+id]
    const row = await db.analyticsCache.get([userId, id]);
    if (!row) return null;
    if (Date.now() - row.updatedAt > ttlMs) return null;
    return row.payload as T;
  },
  async set(id: string, tipo: string, payload: any) {
    const userId = useFiscalStore.getState().userId;
    if (!userId) return;

    await db.analyticsCache.put({ 
      id, 
      userId, 
      tipo, 
      payload, 
      updatedAt: Date.now() 
    });
  },
  async invalidateByTipo(tipo: string) {
    const userId = useFiscalStore.getState().userId;
    if (!userId) return;

    await db.analyticsCache
      .where("userId").equals(userId)
      .and(row => row.tipo === tipo)
      .delete();
  },
  async clear() {
    const userId = useFiscalStore.getState().userId;
    if (!userId) return;

    await db.analyticsCache.where("userId").equals(userId).delete();
  },
};
